"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateVehicleData = exports.vehicleFormRules = exports.vehicleFieldMapping = exports.vehicleSchema = void 0;
const converters_1 = require("../converters");
exports.vehicleSchema = {
    fields: {
        make: {
            maxLength: 50,
        },
        model: {
            maxLength: 50,
        },
        color: {
            maxLength: 20,
        },
        year: {
            pattern: /^\d{1,4}$/,
            maxLength: 4,
            custom: {
                validate: (value) => {
                    if (!value)
                        return true; // Allow empty since it's not required
                    const year = parseInt(value);
                    const currentYear = new Date().getFullYear();
                    return year >= 1900 && year <= currentYear; // Reasonable range
                },
                message: 'Year must be current year or earlier',
            },
        },
        license_plate_number: {
            maxLength: 20,
        },
    },
    messages: {
        make: {
            maxLength: 'Make must be 50 characters or less',
        },
        model: {
            maxLength: 'Model must be 50 characters or less',
        },
        color: {
            maxLength: 'Color must be 20 characters or less',
        },
        year: {
            pattern: 'Year must be a valid numeric value',
            maxLength: 'Year must be less than 4 characters',
            custom: 'Year must be current year or earlier',
        },
        license_plate_number: {
            maxLength: 'License plate number must be 20 characters or less',
        },
    },
};
// Field mapping between DTO naming and UI naming
exports.vehicleFieldMapping = {
    make: 'make',
    model: 'model',
    color: 'color',
    year: 'year',
    license_plate_number: 'license_plate_number',
};
// 🚀 Pre-computed validations for performance
exports.vehicleFormRules = (0, converters_1.toReactHookForm)(exports.vehicleSchema, exports.vehicleFieldMapping);
exports.validateVehicleData = (0, converters_1.createValidator)(exports.vehicleSchema);
